import ContestPick from "../../../ContestPick/ContestPick";
import React, {useEffect} from "react";
import UserParlayFooter from "./UserParlayFooter";
import _ from "lodash";
import './UserParlayRenderer.style.scss';
import {PayoutModel} from "../../../../constants/PickXEnums";
import CreateFromPreSelectedParlayHeader
    from "../CreateFromPreSelectedParlayRenderer/CreateFromPreSelectedParlayHeader";
import {FormattedMessage} from "react-intl";
import PayoutInfoPopUp from "../../../../views/PopUps/PayoutInfoPopUp/PayoutInfoPopUp";
import useAppModalService from "../../../../hooks/useAppModalService";
import Currency from "../../../Currency/Currency";
import {useSelector} from "react-redux";
import {selectLocale} from "../../../../stores/account/account.selectors";

const tKey = "lobbyView.contests.prePackageContest.prePackageContestCard"
const UserParlayRenderer = ({parlay, contests, prizeAsset})=>{

    const {openModal} = useAppModalService();
    const payoutInfos = parlay.getPayouts(contests, prizeAsset);
    const isPrizeAsset = parlay.PayoutModel === PayoutModel.Assets;
    const locale = useSelector(selectLocale);

    const handleViewPayout = async (e) => {
        try {
            await openModal('payoutInfoPopUp', 'info', {
                details: 'Some details about Payout Info',
                modalComponent: PayoutInfoPopUp,
                onOk: () => {},
                onCancel: () => {},
                onClose: () => {},
            }, {
                payoutInfos,
                currency: parlay.WagerCurrency
            });
        } catch (error) {
            console.error('Error opening modal:', error);
        }
    }

    if(!parlay)
        return null;

    return (
        <div className="UserParlayRenderer">
            {parlay.isWon && <div className="won gold-gradient-text">
                <FormattedMessage id={`${tKey}.won`}/> {!isPrizeAsset ? <Currency value={parlay.Payout}
                                                                                 currency={parlay.WagerCurrency}
                                                                                 className="gold-gradient-text" />
                                                                    : <span className="gold-gradient-text">{prizeAsset?.[`Name${_.capitalize(locale)}`]}</span> }
            </div>}
            {(parlay?.PayoutModel === PayoutModel.Pick12 ||
              parlay?.PayoutModel === PayoutModel.Pick16 ||
              parlay?.PayoutModel === PayoutModel.Assets) &&
                <div className="fullPayoutBtn gold-background"
                     onClick={() => handleViewPayout()}>
                    <FormattedMessage id={`${tKey}.fullPayout`}/>
                </div>
            }
            {contests?.map((contest, index) => (
                <ContestPick
                    key={index}
                    contest={contest}
                    parlay={parlay}
                />
            ))}
            <UserParlayFooter parlay={parlay}
                               contests={contests}
                              prizeAsset={prizeAsset}/>
        </div>
    );
};
export default UserParlayRenderer;